export default __webpack_public_path__ + "static/media/google.bbce75f8.svg";